var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 80,
    viewBox: "0 0 93 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4688 40L57.8394 60.1334H34.581L34.5421 60.0666L23.0664 79.9337L23.1053 80H46.2099H69.315L80.8679 60.0003L92.4202 40H69.4688Z",
    fill: "url(#paint0_linear_704_9151)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8394 19.8666L69.4688 40H92.4202L80.8679 20.0003L69.315 0H46.2099H23.1053L23.0664 0.06686L34.5421 19.9334L34.581 19.8666H57.8394Z",
    fill: "url(#paint1_linear_704_9151)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9514 40.0001L34.542 19.9336L34.5037 19.8667H11.6295L11.5523 20.0004L0 40.0001L11.5523 60.0004L11.6295 60.1336H34.5037L34.542 60.0667L22.9514 40.0001Z",
    fill: "url(#paint2_linear_704_9151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_9151",
    x1: 96.8221,
    y1: 37.8845,
    x2: 25.316,
    y2: 89.1403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "#007FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#0077A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#024D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#035295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#026E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0178A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_704_9151",
    x1: 26.021,
    y1: -4.98398,
    x2: 100.053,
    y2: 37.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#0077A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#008EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_704_9151",
    x1: 3.92924,
    y1: 73.1308,
    x2: 44.8546,
    y2: 2.21324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0869,
    stopColor: "#E61912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2169,
    stopColor: "#E83B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3741,
    stopColor: "#EB5E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5524,
    stopColor: "#F18800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7484,
    stopColor: "#F9B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    stopColor: "#FFE800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo_transparent.6ecf3680f1c83c8a6c7a6d7dbcc5d139.svg";
export { ForwardRef as ReactComponent };